export default __webpack_public_path__ + "static/media/rifles-5.276800d1.svg";